<template>
  <div>
    <div class="workbench-toolbar">
      <div class="workbench-toolbar__info">
        <div
          class="workbench-toolbar__info__dashboard"
          @click="navigateToDashboard"
        >
          <v-icon
            dark
            color="#C6CCD0"
            >mdi-view-dashboard</v-icon
          >
          <!-- <v-icon dark color="#C6CCD0">mdi-speedometer-slow</v-icon> -->
          <div class="text-button pl-1">Dashboard</div>
        </div>
        <div class="workbench-toolbar__info__status_destination">
          <div
            class="workbench-toolbar__info__status_destination__target_name"
            v-if="activated && currentTarget && currentTarget.display_name"
          >
            {{ currentTarget.display_name }}&nbsp;&nbsp;|
          </div>
          <div class="workbench-toolbar__info__status_destination__destination text-overline">
            {{ currentTarget.target_datasource }}
          </div>
          <div
            class="workbench-toolbar__info__status_destination__destination"
            v-if="currentTarget && currentTarget.viewing_stream"
          >
            {{ currentTarget.viewing_stream }}
          </div>
          <div
            class="workbench-toolbar__info__status_destination__destination"
            v-if="
              currentTarget && currentTarget.target_type && currentTarget.target_type === audienceDiscoveryTargetType
            "
          >
            Audience Discovery
          </div>
          <v-chip
            label
            small
            dark
            class="workbench-toolbar__info__status_destination__status"
            v-if="!dropped && currentTarget && currentTarget.activation_status"
            >{{ currentTarget.activation_status }}</v-chip
          >
          <div
            class="workbench-toolbar__info__status_destination__status__dropped"
            v-else-if="dropped"
            @click="clickedDropped"
          >
            DROPPED
          </div>
        </div>
      </div>
      <metrics-banner
        :metrics="metrics"
        :loading="loading"
      ></metrics-banner>
    </div>
    <template v-if="showGraphs">
      <distribution-graph-area class="workbench-toolbar__topArea"> </distribution-graph-area>
    </template>
    <dropped-attributes-modal />
  </div>
</template>
<script>
  import BackButton from '@/appComponents/oldWorkbench/attributePanel/BackButton'
  import Flag from '@/components/common/flag'
  import MetricsBanner from './MetricsBanner'
  import SvgIcon from '@/components/common/svgIcon'
  import junkDrawerIcon from '@/assets/svg/junk-drawer.svg'
  import DistributionGraphArea from '@/appComponents/oldWorkbench/distributionGraphs/DistributionGraphArea'
  import { SHOW_DROPPED_ATTRIBUTES_MODEL } from '@/views/workbench/LAS/store/mutations'
  import DroppedAttributesModal from '@/appComponents/targets/components/modals/DroppedAttributesModal'
  import { TARGET_TYPES_INTEGERS, INTENTS, ACTIVATION_STATUS } from '@/appLogic/targets/Constants'
  import { ROUTE_BACK } from '@/appLogic/route/store/actions'
  import { SET_CURRENT_TARGET } from '@/appLogic/targets/currentTarget/store/actions'
  import { deleteTarget } from '@/api'

  export default {
    components: {
      MetricsBanner,
      SvgIcon,
      Flag,
      BackButton,
      DistributionGraphArea,
      DroppedAttributesModal,
    },
    props: {
      name: String,
      metrics: {
        type: Object,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      menu: {
        type: Array,
        default: () => [],
      },
      activated: {
        type: Boolean,
        default: false,
      },
      showGraphs: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        junkDrawerIcon,
        audienceDiscoveryTargetType: TARGET_TYPES_INTEGERS.AD,
        lasTargetType: TARGET_TYPES_INTEGERS.LAS,
        sdTargetType: TARGET_TYPES_INTEGERS.SD,
      }
    },
    computed: {
      username() {
        // use Auth getter to get usename for route back to target manager screen
        return this.$store.getters.username
      },
      dropped() {
        return this.$store.state.las && this.$store.state.las.isDropped
      },
      currentTarget() {
        return this.$store.getters.currentTarget
      },
      // hasMarketingPermsAndIntent () {
      //   const marketingIntent = this.currentTarget && this.currentTarget.metadata && (this.currentTarget.metadata.intents || []).find(i => i.Name === INTENTS.Marketing.Name)
      //   return marketingIntent && this.$store.getters.hasMarketingCreateEditPermissions
      // },
    },
    methods: {
      navigateToDashboard() {
        if (this.currentTarget.activation_status === ACTIVATION_STATUS.DRAFT) {
          deleteTarget(this.currentTarget)
            .then(function (response) {
              console.log(response)
            })
            .catch(function (err) {
              console.log(err)
            })
        }
        this.$store.commit(SET_CURRENT_TARGET, { target_definition: { promotedNetworks: '' } })
        this.$store.dispatch(ROUTE_BACK)
      },
      clickedDropped() {
        // Show a new modal that displays the dropped attributes per quarter
        /**
         * 2. Call the API to get the values
         * 3. Show a loading dots until the api is finished
         * 4. Create the display to show the values in the modal
         */
        this.$store.dispatch(SHOW_DROPPED_ATTRIBUTES_MODEL)
      },
    },
  }
</script>
<style lang="scss">
  $header-nav-font-color: #c6ccd0;
  $status-btn-background-color: #676d74;
  $attribute-panel-background-color: #435261;

  .workbench-toolbar {
    display: flex;
    width: 100%;
    height: rem(60);
    padding-left: rem(15);
    padding-right: rem(15);
    flex-shrink: 0;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    color: white;
    background-color: #232a32;
    &__info {
      display: flex;
      align-items: center;
      margin-left: rem(-20);
      justify-content: space-between;
      .back-btn {
        padding: rem(5) rem(15) rem(5) 0;
      }
      &__dashboard {
        cursor: pointer;
        display: flex;
        align-items: center;
        text-transform: uppercase;
        color: $header-nav-font-color;
        padding-left: 1.5em;
        border-right: 2px solid $attribute-panel-background-color;
        padding-right: 1.5em;
        height: 4em;
      }
      &__status_destination {
        display: flex;
        text-transform: uppercase;
        align-items: center;
        width: 100%;
        &__target_name {
          margin-left: 1em;
          width: 100%;
        }
        &__destination {
          margin: 0 1em;
        }
        &__status {
          font-weight: 700;
          padding: 0.25em 1.1em;
          background-color: $status-btn-background-color;
          border: 1px solid $header-nav-font-color;
          border-radius: 8px;
          font-size: 0.85em;
          letter-spacing: 1.5px;
          &__dropped {
            font-weight: 700;
            padding: 0.25em 1.1em;
            background-color: $status-btn-background-color;
            border: 1px solid $header-nav-font-color;
            border-radius: 8px;
            font-size: 0.85em;
            letter-spacing: 1.5px;
            cursor: pointer;
          }
        }
      }
    }

    &__topArea {
      flex: 1 100%;
      max-width: 100%;
    }
    &__icon {
      fill: white;
      cursor: pointer;
      width: rem(38) !important;
      height: rem(30) !important;
    }
    .viewOnly {
      pointer-events: none;
    }
  }
</style>



// WEBPACK FOOTER //
// WorkbenchToolbar.vue?cd623880